import { TypedDocumentNode, gql } from '@apollo/client';

import { ScoreStatus } from '__generated__/globalTypes';

import { Score } from '../Score';
import { PlayerGameScoreScore_playerGameScoreInterface } from './__generated__/index.graphql';

type Props = {
  playerGameScore?: PlayerGameScoreScore_playerGameScoreInterface;
};

export const PlayerGameScoreScore = ({ playerGameScore }: Props) => {
  const { score, scoreStatus } = playerGameScore || {};

  return (
    <Score
      hideReviewing
      shape="HEXAGON"
      score={score || 0}
      scoreStatus={
        typeof score === 'number' && scoreStatus
          ? scoreStatus
          : ScoreStatus.DID_NOT_PLAY
      }
      scoreType="PLAYER_SCORE"
    />
  );
};

PlayerGameScoreScore.fragments = {
  playerGameScoreInterface: gql`
    fragment PlayerGameScoreScore_playerGameScoreInterface on PlayerGameScoreInterface {
      id
      score
      scoreStatus
    }
  ` as TypedDocumentNode<PlayerGameScoreScore_playerGameScoreInterface>,
};
